import React, { useState } from "react";

const CourseList: React.FC<{ courses: string[] }> = ({ courses }) => {
  const [showAll, setShowAll] = useState(false);
  const visibleCourses = showAll ? courses : courses.slice(0, 4);
  const remainingCount = courses.length - 4;

  return (
    <>
      {visibleCourses.map((course, index) => (
        <span key={index}>
          {course}
          {index < visibleCourses.length - 1 && <span className="px-1">/</span>}
        </span>
      ))}
      {courses.length > 4 && (
        <button
          onClick={() => setShowAll(!showAll)}
          className="ml-2 text-blue underline text-sm"
        >
          {showAll ? "Show less" : `+${remainingCount} more`}
        </button>
      )}
    </>
  );
};

export default CourseList;
